import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RyderButton from '../RyderButton';
import RyderInput from '../RyderInput';
import Spinner from '../Spinner';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  injectStripe,
} from 'react-stripe-elements';
import {
  validateEmail,
  formatMoney,
} from '../../utils/helper';
import theme from '../../themes/main';
import SweetAlert from 'sweetalert-react';
import 'sweetalert/dist/sweetalert.css';
import axios from '../../utils/axios';
import {
  FormContainer,
  ElementContainer,
  InnerContainer,
  CardContainer
} from './styledComponents';

/**
 * StripePaymentForm Component documentation
 * @property       {object} invoice Object to store data of invoice
 * @property       {func} onBack Function to handle Back event
 * @property       {string} accountNumber String to store account number to be sent to pay-invoice endpoint
 *
 */

class StripePaymentForm extends Component {
  state = {
    errorData: false,
    emailAddress: '',
    showSpinner: false,
    alertData: {
      showAlert: false,
      alertMessage: '',
      alertIcon: 'success',
      alertTitle: 'Success...',
    },
  };

  componentDidMount() {
    this.setState({
      errorData: false,
      emailAddress: '',
      showSpinner: false,
      alertData: {
        showAlert: false,
        alertMessage: '',
        alertIcon: 'success',
        alertTitle: 'Success...',
      },
    });
  }
  handleCharge = ( token ) => {
    const {
      invoice: {
        id,
        customer,
      },
      accountNumber,
    } = this.props;
    const {
      emailAddress,
    } = this.state;
    axios.post('/pay-invoice', { token, invoiceId: id, customer, email: emailAddress, accountNumber })
          .then((result) => {
            if(result.status === 200 && result.data.success) {
              this.setState({
                showSpinner: false,
                alertData: {
                  showAlert: true,
                  alertIcon: 'success',
                  alertMessage: 'Thanks for your payment. We have sent an confirmation email to the email address on file for your records.',
                  alertTitle: 'Success...',
                },
              });
            }
            else
              this.setState({
                showSpinner: false,
                alertData: {
                  showAlert: true,
                  alertIcon: 'error',
                  alertMessage: result.data.data.message,
                  alertTitle: 'Oops...',
                },
              });
          }).catch((error) => {
            let errorMessage = 'An Error has ocurred.';

            if (error.response) {
              if(error.response.data && error.response.data.data && error.response.data.data.message)
                 errorMessage = error.response.data.data.message;
              else if(error.request.statusText)
                errorMessage = error.message + ' (' + error.request.statusText + ').';
            } else if (error.request && error.request.statusText)
              errorMessage = error.message + ' (' + error.request.statusText + ').';
            else
              errorMessage = error.message;

            this.setState({
              showSpinner: false,
              alertData: {
                showAlert: true,
                alertIcon: 'error',
                alertMessage: errorMessage,
                alertTitle: 'Oops...',
              },
            });
          });
  };
  handleSubmit = (ev) => {
    ev.preventDefault();
    this.validateError();
    const {
      errorData,
    } = this.state;
    if(!errorData) {
      this.setState({ showSpinner: true });
      if (this.props.stripe) {
        this.props.stripe
          .createToken()
          .then(({ token, error }) => {
            if(error) {
              this.setState({
                showSpinner: false,
                alertData: {
                  showAlert: true,
                  alertIcon: 'error',
                  alertMessage: error.message,
                  alertTitle: 'Oops...',
                },
              });
            }
            else {
              this.handleCharge(token);
            }
          });
      } else {
        this.setState({
          showSpinner: false,
          alertData: {
            showAlert: true,
            alertIcon: 'error',
            alertMessage: 'An Error has ocurred.',
            alertTitle: 'Oops...',
          },
        });
        console.log("Stripe.js hasn't loaded yet.");
      }
    }
  };
  validateError = () => {
    const {
      emailAddress,
    } = this.state;
    if (emailAddress && emailAddress !== '' && !validateEmail(emailAddress)) {
      this.setState({
        errorData: true,
      });
    } else {
      this.setState({
        errorData: false,
      });
    }
  };
  setData = (text, name) => {
    this.setState({ emailAddress: text });
    if (text && text !== '' && !validateEmail(text)) {
      this.setState({
        errorData: true,
      });
    } else {
      this.setState({
        errorData: false,
      });
    }
  };
  getErrorText = (field) => {
    const {
      emailAddress,
    } = this.state;
    if(field === 'emailAddress')
      return !validateEmail(emailAddress) ? 'Please, enter a valid Email address' : '';
    else
      return '';
  };
  hideAlert = () => {
    const {
      alertData,
    } = this.state;
    const {
      onBack,
    } = this.props;
    this.setState({
      alertData: {
        ...alertData,
        showAlert: false,
      }
    });
    if(alertData.alertIcon === 'success')
      onBack('search');
  };
  render() {
    const {
      errorData,
      emailAddress,
      showSpinner,
      alertData: {
        showAlert,
        alertMessage,
        alertIcon,
        alertTitle,
      },
    } = this.state;
    const {
      invoice,
    } = this.props;
    const createOptions = (fontSize, padding) => {
      return {
        style: {
          base: {
            letterSpacing: '0.025em',
            fontFamily: 'Source Code Pro, monospace',
            '::placeholder': {
              color: theme.palette.lightBlueGrey,
            },
          },
          invalid: {
            color: theme.palette.darkRed,
          },
        },
        required: true,
      };
    };
    return (
      <FormContainer onSubmit={this.handleSubmit}>
        <RyderInput
          key={'emailAddress'}
          label={'Email address'}
          name={'emailAddress'}
          type={'text'}
          required
          value={emailAddress}
          onChange={this.setData}
          errorText={errorData ? this.getErrorText('emailAddress') : ''}
          className="label-top"
        />
        <CardContainer>
          <ElementContainer className="card-number">
            <label htmlFor={'card-element'}>Card number<span className="required-mark">*</span></label>
            <InnerContainer>
              <CardNumberElement
                {...createOptions()}
              />
            </InnerContainer>
          </ElementContainer>
          <ElementContainer className="exp-element">
            <label htmlFor={'exp-element'}>Expiration date<span className="required-mark">*</span></label>
            <InnerContainer>
              <CardExpiryElement
                {...createOptions()}
              />
            </InnerContainer>
          </ElementContainer>
          <ElementContainer className="cvc-element">
            <label htmlFor={'cvc-element'}>CVC<span className="required-mark">*</span></label>
            <InnerContainer>
              <CardCVCElement
                {...createOptions()}
              />
            </InnerContainer>
          </ElementContainer>
        </CardContainer>
        <RyderButton>Pay{invoice.amount_due !== '' && ' ' + formatMoney(invoice.amount_due/100)}</RyderButton>
        <SweetAlert
          title={alertTitle}
          show={showAlert}
          type={alertIcon}
          text={alertMessage}
          onConfirm={this.hideAlert}
        />
        { showSpinner && <Spinner /> }
      </FormContainer>
    );
  }
}

StripePaymentForm.propTypes = {
  invoice: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
  accountNumber: PropTypes.string.isRequired,
};

export default injectStripe(StripePaymentForm);



// WEBPACK FOOTER //
// ./src/components/StripePaymentForm/index.js